import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import { isOfferActive } from '@/lib/offers';
import type { Offer } from '@/lib/types';

interface OfferRow {
  offer_id: string;
  product_id: string;
  offer: Offer | null;
}

// Devuelve un mapa producto_id -> Oferta activa (solo ofertas habilitadas y vigentes
// según fecha/hora actual). Se usa tanto en el catálogo público como en el POS.
export function useActiveOffers(productIds: string[]) {
  const [offersByProduct, setOffersByProduct] = useState<Record<string, Offer>>({});
  const [loading, setLoading] = useState(false);

  const key = productIds.join(',');

  useEffect(() => {
    const ids = productIds.filter(Boolean);
    if (ids.length === 0) {
      setOffersByProduct({});
      setLoading(false);
      return;
    }
    let active = true;
    setLoading(true);
    (async () => {
      const { data } = await supabase
        .from('offer_products')
        .select('offer_id, product_id, offer:offers(id, name, percentage, starts_at, ends_at, active)')
        .in('product_id', ids);
      if (!active) return;
      const map: Record<string, Offer> = {};
      for (const row of (data as OfferRow[]) ?? []) {
        const offer = row.offer;
        if (offer && isOfferActive(offer)) {
          map[row.product_id] = offer;
        }
      }
      setOffersByProduct(map);
      setLoading(false);
    })();
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return { offersByProduct, loading };
}